// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3OtvL","header":"ReportDetails_header__FeATH","title":"ReportDetails_title__35A2F","left":"ReportDetails_left__1rD6f"};